import fromPairs from 'lodash/fromPairs';

import budgets from './budgets-deprecated';
import ChangeBudgetComment from './ChangeBudgetComment';

export default {
  label: 'Change Budget',
  value: 'Change Budget',
  Comment: ChangeBudgetComment,
  patch(campaign, change) {
    const updatedBudgets = budgets.filter(
      ({ key }) => campaign[key] !== change[key],
    );
    return fromPairs(updatedBudgets.map(({ key }) => [key, change[key]]));
  },
  Form: () => null,
  initialState: () => ({}),
  inactive: true,
};
